import React, { useState, useEffect } from "react";
import CustomerModal from "../components/CustomerEditModal";
import CustomerCreateModal from "../components/CustomerCreateModal";
import { oddController } from "../controllers/oddsController/oddController";
import ReactPaginate from "react-paginate";
import color from "../config/color";
import Loading from "../components/Loading";
import { useTranslation } from "react-i18next";

function Customer(props) {
  const {theme} = props;
  const userInfo=JSON.parse(localStorage.getItem("USR"));
  const {t} = useTranslation("global");
  const rowsPerPage = 8;
  const [pageCount, setPageCount] = useState(0);
  const [page, setPage] = useState(0);
  const [searchText, setSearchText] = useState([]);

  const [customerInfo, setCustomerInfo] = useState([]);
  const [searchCustomer,setSearchCustomer] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [customerData, setCustomerData] = useState({
    customerName: "",
    commission: 0,
    customerId: 0,
    betLimit :0,
    active: false,
  });
  const [newcustomerData, setNewCustomerData] = useState({
    customerName: "",
    commission: 0,
    customerId: 0,
    betLimit :0,
    active: true,
  });

  useEffect(() => {
    getCustomer();
  }, []);

  const handlePageClick = async (data) => {
    setPageCount(data.selected);
  };

  const cancelSearch = () => {
    setSearchText("");
    setSearchCustomer(customerInfo);
    setPage(Math.ceil(customerInfo.length / rowsPerPage));
  };

  const handleSerch = (e) => {
    setSearchText(e.target.value);
    if (e.target.value.length != 0) {
      const filteredRows = customerInfo.filter((row) => {
        return row.customerName
          .toLowerCase()
          .includes(e.target.value.toLowerCase());
      });
      setSearchCustomer(filteredRows);
      setPage(Math.ceil(filteredRows.length / rowsPerPage));
    } else {
      setSearchCustomer([...customerInfo]);
      setPage(Math.ceil(customerInfo.length / rowsPerPage));
    }
  };

  const getCustomer = () => {
    setLoading(true);
    oddController.getCustomer(parseInt(userInfo.oddsUserId), (data) => {

      setCustomerInfo(data.customer);
      setSearchCustomer(data.customer);
      setPage(Math.ceil(data.customer.length / rowsPerPage));
      setLoading(false);
    });
  };

  const OnEditClick = (customer, commission, customerId, active,betLimit) => {
    const newedit = { ...customerData };
    newedit["customerName"] = customer;
    newedit["commission"] = commission;
    newedit["customerId"] = customerId;
    newedit["betLimit"] = betLimit;
    newedit["active"] = active;
    setCustomerData(newedit);
  };

  // const OnCreateClick = (customer, commission, customerId, active) => {
  //   const newedit = { ...customerData };
  //   newedit["customerName"] = customer;
  //   newedit["commission"] = commission;
  //   newedit["customerId"] = customerId;
  //   newedit["active"] = active;
  //   setCustomerData(newedit);
  // };

  return (
    <div>
      <CustomerModal
        customerdata={customerData}
        setCustomerData={setCustomerData}
        getCustomer={getCustomer}
        setLoading={setLoading}
        theme={theme}
        t={t}
      />
      <CustomerCreateModal
        setNewCustomerData={setNewCustomerData}
        newcustomerData={newcustomerData}
        getCustomer={getCustomer}
        setLoading={setLoading}
        t={t}
        theme={theme}
        userInfo={userInfo}
      />
      {isLoading ? (
        <div style={{ width:'100%',display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'column' }}>
          <Loading />
          <p>Loading .....</p>
        </div>
      ) : (
        <div>
          <span className="site-header" style={{color:color[theme].main}}>{t('customer')}</span>
          <div className="customer-header">
          <div className="input-gp">
              <input
                type="email"
                className="custom-input"
                id="exampleFormControlInput1"
                placeholder="search ..."
                style={{ width: 160,height:38,fontSize:'0.8rem' }}
                value={searchText}
                onChange={(e) => handleSerch(e)}
              />
              <button
                type="button"
                className="btn btn-light"
                onClick={() => cancelSearch()}
              >
                <i
                  className="fa-solid fa-circle-xmark"
                  style={{ fontSize: 15 }}
                ></i>
              </button>
            </div>
            <button
              type="button"
              className="btn"
              style={{backgroundColor:color[theme].main,color:'#fff',fontSize:'0.8rem'}}
              data-bs-target="#customeraddModal"
              data-bs-toggle="modal"
            >
              <i className="fas fa-add my-icon"></i>&nbsp;{t('addNew')}
            </button>
          </div>
          <div className="table-responsive">
            <table className="table">
              <thead style={{fontSize:'0.85rem',backgroundColor:color[theme].headerbg}}>
                <tr>
                  <th scope="col">{t('no')}</th>
                  <th scope="col">{t('name')}</th>
                  <th scope="col">{t('commission')}</th>
                  <th scope="col">{t('betLimit')}</th>
                  <th scope="col">{t('action')}</th>
                </tr>
              </thead>
              <tbody style={{fontSize:'0.8rem'}}>
                {searchCustomer.length != 0 ?
                searchCustomer &&
                  searchCustomer
                    .slice(
                      pageCount * rowsPerPage,
                      pageCount * rowsPerPage + rowsPerPage
                    )
                    .map((d, i) => {
                      return (
                        <tr key={d.customerId}>
                          <th scope="row">{i + 1}</th>
                          <td>{d.customerName}</td>
                          <td>{d.commission}%</td>
                          <td>{d.betLimit}</td>
                          <td>
                            <button
                              className="btn"
                              style={{backgroundColor:color[theme].main,color:'#fff',fontSize:'0.8rem'}}
                              data-bs-toggle="modal"
                              data-bs-target="#customerModal"
                              onClick={() =>
                                OnEditClick(
                                  d.customerName,
                                  d.commission,
                                  d.customerId,
                                  d.active,
                                  d.betLimit
                                )
                              }
                            >
                              <i className="fas fa-edit my-icon"></i>&nbsp;{t('edit')}
                            </button>
                          </td>
                        </tr>
                      );
                    })
                  :
                  <tr>
              <td colSpan={4} style={{textAlign:'center'}}>{t('nodata')}</td>
            </tr>
                  }
              </tbody>
            </table>
          </div>
          <ReactPaginate
            previousLabel={t('previous')}
            nextLabel={t('next')}
            breakLabel={"..."}
            pageCount={page}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            onPageChange={handlePageClick}
            containerClassName={"pagination justify-content-center"}
            pageClassName={"page-item"}
            pageLinkClassName={"page-link"}
            previousClassName={"page-item"}
            previousLinkClassName={"page-link"}
            nextClassName={"page-item"}
            nextLinkClassName={"page-link"}
            breakClassName={"page-item"}
            breakLinkClassName={"page-link"}
            activeClassName={"active"}
          />
        </div>
      )}
    </div>
  );
}

export default Customer;

